import http from "../http-common-dnc";

class CargoContratoService {

    getByIdContrato(id_contrato) {
        return http.get(`/cargocontrato/getidcont/${id_contrato}`);
    }

    dncByContrato(nombre_unidad) {
        return http.get(`/dnc/centrocosto/${nombre_unidad}`);
    }
}

export default new CargoContratoService();